import config from './config.js'

export default {

  // load rule
  load: function(id,cb_success) {
    fetch(config.baseUrl + 'rest/scripts/' + encodeURIComponent(id),{ credentials: 'include' }).then(resp => resp.json()).then(cb_success);
  },

  // load rule
  save: function(rule,cb_success) {
    fetch(config.baseUrl + 'rest/scripts/' + encodeURIComponent(rule.ruleId),{
      credentials: 'include',
      method: 'PUT',
      body: JSON.stringify(rule),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(resp => resp.json()).then(cb_success);
  },

  testordercheck: function(ctrl,id,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/orders/precheck?map_id=' + encodeURIComponent(id),'Bestellprüfung testen',JSON.stringify(data),cb_success);
  },

  testpricecalc: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/config/checkprice?oid=' + encodeURIComponent(id),'Preisberechnung testen',cb_success);
  }


}
